import { createSlice } from "@reduxjs/toolkit";

const toastSlice = createSlice({
  name: "toast",
  initialState: { toasts: [] },
  reducers: {
    showToast: (state, action) => {
      state.toasts.push({
        id: Date.now(),
        message: action.payload.message,
        severity: action.payload.severity || "success",
      });
    },
    hideToast: (state, action) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
